import { notifications } from "@mantine/notifications";

export const notifyIfFirstItemChanged = (
  newItems: any[],
  existingItems: any[],
  getKey: (item: any) => string,
  getStamp: (item: any) => number,
  notificationTitle: string,
  notificationMessage: (item: any) => string,
  color: string
) => {
  console.log("in notifyIfFirstItemChanged");
  console.log("newItems", newItems);
  console.log("existingItems", existingItems);

  if (newItems.length > 0 && existingItems.length > 0) {
    const firstNewItem = newItems[0];
    const firstExistingItem = existingItems[0];

    console.log("firstNewItem", firstNewItem);
    console.log("firstExistingItem", firstExistingItem);

    const newKey = getKey(firstNewItem);
    const existingKey = getKey(firstExistingItem);
    const newStamp = getStamp(firstNewItem);
    const existingStamp = getStamp(firstExistingItem);

    console.log("newKey", newKey);
    console.log("existingKey", existingKey);
    console.log("newStamp", newStamp);
    console.log("existingStamp", existingStamp);

    if (newKey !== existingKey || newStamp !== existingStamp) {
      console.log("Key or stamp has changed. Showing notification.");
      notifications.show({
        color: color,
        title: notificationTitle,
        message: notificationMessage(firstNewItem),
      });
    } else {
      console.log("Key and stamp are the same. No notification.");
    }
  } else if (newItems.length > 0 && existingItems.length === 0) {
    console.log(
      "No existing items but there are new items. Showing notification for the first new item."
    );
    notifications.show({
      title: notificationTitle,
      message: notificationMessage(newItems[0]),
    });
  } else {
    console.log("No new items or no existing items. No notification.");
  }
};
